<template>
  <ListPanel
    ref="panel"
    mode="mine"
    :fetch-list="fetchMineList"
    @selection-change="onSelectionChange"
  >
    <template #extra-action>
      <a-button :disabled="!canReapply" @click="reapplySelected">工单申请</a-button>
      <a-button type="primary" @click="newOrder">新建工单</a-button>
    </template>
  </ListPanel>
</template>

<script>
import ListPanel from "./components/list-panel.vue";
import { fetchMineList } from "@/api/oa/workOrder";

export default {
  name: "workOrderMine",
  components: { ListPanel },
  data() {
    return {
      fetchMineList,
      selectedRowKeys: [],
    };
  },
  computed: {
    // 仅勾选一条工单时可点击；复选框本身只允许勾选"已终止"的工单
    canReapply() {
      return this.selectedRowKeys.length === 1;
    },
  },
  methods: {
    newOrder() {
      this.$router.push("/oa/workOrder/add");
    },
    onSelectionChange(keys) {
      this.selectedRowKeys = keys;
    },
    reapplySelected() {
      this.$refs.panel && this.$refs.panel.reapplySelected();
    },
  },
};
</script>
